import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Highlighteable } from '../Text';
import theme from '../../theme';

const LocationInfo = ({ location }) => {
  const { t } = useTranslation();
  const darkgray = 'darkgray';

  if (!location) {
    return t('COMMON.MISSING');
  }

  return (
    <span style={{ display: 'inline-flex', flexDirection: 'column' }}>
      <span style={{ color: theme.color.primary, lineHeight: 1.2 }}>
        <Highlighteable
          content={location.locationReferenceIdentifier}
          search={location.locationReferenceIdentifier}
        />
      </span>
      {location.name && (
        <span style={{ lineHeight: 1.2 }}>
          <Highlighteable content={location.name} color={darkgray} />
        </span>
      )}
    </span>
  );
};

LocationInfo.propTypes = {
  location: PropTypes.shape({
    locationReferenceIdentifier: PropTypes.string,
    name: PropTypes.string,
  }),
};

LocationInfo.defaultProps = {
  location: null,
};

export default LocationInfo;
